<div class="interest__newsletter">
  <div class="newsletter-title">Newsletter</div>
  <div class="newsletter-info">{{"dejanosTuEmailYTeMantendremosAlTantoDeLasNoticiasDelClub" | transloco}}</div>
  <form [formGroup]="newsletterform" class="newsletter-form" (ngSubmit)="singinNewsletter()">
    <div class="form-row">
      <input formControlName="email" class="form-text" placeholder="{{'escribeTuEmail' | transloco}}" aria-label="Email" required>
      <div class="field-error" *ngIf="formValidationService.hasError(newsletterform, 'email', 'required', strict)">
        El correo electrónico es obligatorio
      </div>
      <div class="field-error" *ngIf="formValidationService.hasError(newsletterform, 'email', 'email', strict)">
        Debe indicar un correo electónico válido
      </div>
      <div class="form-row">
        <label class="form-check" for="accept">
          <input id="accept" formControlName="terms" class="form-check-input" type="checkbox" (change)="markAsTouched()">{{"aceptoLas" | transloco}}
          <a target="_blank"
             href="https://www.realbetisbalompie.es/media/files/rbetis/pdf/condicionesgeneralesdeusorbb.pdf">
            {{"condiciones" | transloco}}.
          </a>
        </label>
      </div>
      <div class="field-error" *ngIf="formValidationService.hasError(newsletterform, 'terms', 'required', strict)">
        Debe aceptar las condiciones de uso
      </div>
      <button class="btn btn-secondary">{{"suscribirme" | transloco}}</button>
    </div>

  </form>
</div>
